<template>
	<GridContextMenuMobile
		:is-open="isOpen"
		:menu-items="menuItems"
		:context-data="eventTag"
		@item-click="(id, action, data) => $emit('item-click', id, action, data)"
		@close="$emit('close')"
	>
		<template #header>
			<div class="title-wrapper">
				<div class="title">
					<span class="event-name">
						{{ eventName }}
					</span>
					<span class="event-type">
						<Icon
							:icon-name="eventTagIcon"
							size="sm"
							:is-sport-icon="true"
						/>
					</span>
					<span class="event-time">
						{{ eventTime }}
					</span>
				</div>
				<div class="subtitle">
					<span v-if="teamName">{{ teamName }}</span>
					<span
						v-if="teamName && playerName"
						class="bullet"
					>&bullet;</span>
					<span v-if="playerName">{{ playerName }}</span>
				</div>
			</div>
		</template>
	</GridContextMenuMobile>
</template>

<script>
import GridContextMenuMobile from './GridContextMenuMobile';
import { mapGetters } from 'vuex';
export default {
	name:       'EventTagContextMenuMobile',
	components: { GridContextMenuMobile },
	props:      {
		isOpen: {
			type:    Boolean,
			default: false,
		},
		menuItems: {
			type:    Array,
			default: () => [],
		},
		eventTag: {
			type:     Object,
			required: true,
		},
	},
	computed: {
		...mapGetters({
			sportName: 'event/sportName',
		}),
		eventTagIcon() {
			return `tag-${this.eventTag.name}`;
		},
		eventName() {
			return this.transTagLabel(this.eventTag.name, this.sportName, this.eventTag.tag?.type);
		},
		eventTime() {
			return this.eventTag.formattedTimestamp;
		},
		teamName() {
			return this.eventTag.teamName;
		},
		playerName() {
			return this.eventTag.playerName;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@videotools/sass/_fonts';
@import '@shared/sass/shared-variables';

::v-deep {
	.modal--content.mobile {
		background: var(--color-grey-850);
	}

	.mobile .modal--body {
		padding: 0;
	}
}

.title {
	margin-bottom: 3px;
	display: flex;
	align-items: center;
}

.event-name {
	@include text-md-2;
	margin-right: 8px;
}

.event-time {
	@include text-sm-2;
	margin-left: 8px;
}

.subtitle {
	@include text-sm-2;

	.bullet {
		padding: 0 4px;
	}
}
</style>
